import { graphql } from 'react-relay';
export const SpaceIdentifiersQuery = graphql`
	query SpaceIdentifiersQuery($spaceKey: String) {
		space(key: $spaceKey) {
			id
			key
		}
	}
`;
